import React from 'react';
import { CircularProgress, Backdrop } from '@mui/material';

interface LoadingOverlayProps {
  open: boolean;
  global?: boolean; // New prop
}

const LoadingOverlay: React.FC<LoadingOverlayProps> = ({ open, global = false }) => {
  return (
    <Backdrop
      sx={{
        color: '#fff',
        zIndex: (theme) => theme.zIndex.drawer + 1,
        position: global ? 'fixed' : 'absolute', // Conditional position
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
      }}
      open={open}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  );
};

export default LoadingOverlay;
